/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import './style.scss';
import { useWorkAssignment } from 'hooks';
import moment from 'moment';

function ContactPage() {
  const { searchWorkAssignment } = useWorkAssignment();

  useEffect(() => {
    document.title = `Kontakta oss - TFV Tolkportal`;
    const searchDateRange = {
      start: moment().subtract(1, 'months'),
      end: moment().add(1, 'months'),
    };
    searchWorkAssignment(false, searchDateRange, true);
  }, []);

  return (
    <div>
      <div className="page_content">
        <div className="page-title">
          <div className="title">Kontakta oss</div>
          {/* <div className="contact_now_button_wrapper">
            <button type="button" className="contact_now_button">
              {Translate({
                content: 'contact.sendTFVAnEmail',
              })}
            </button>
          </div> */}
        </div>
        <div className="contact_card_wrapper">
          <img
            src="../../../../images/contact-cover.png"
            style={{
              height: '250px',
              width: '100%',
              marginTop: '15px',
              objectFit: 'cover',
            }}
            alt="contact cover"
          />

          <div className="contact_card_wrapper-details">
            <div>
              <div className="page-title__new">Telefon</div>
              <div className="page-section-body__new">0770-813 000</div>
            </div>
            <div>
              <div className="page-title__new">Postadress</div>
              <div className="page-section-body__new">Tolkförmedling Väst</div>
              <div className="page-section-body__new">Box 113 05</div>
              <div className="page-section-body__new">404 27 Göteborg</div>
            </div>
            <div>
              <div className="page-title__new">Besöksadress</div>
              <div className="page-section-body__new">
                Johan på Gårdas gata 5A, 4 tr
              </div>
              <div className="page-section-body__new">412 50 Göteborg</div>
            </div>
            <div className="page-title__new">
              <a
                href="https://www.tolkformedlingvast.se/ovrigt/kontakta-oss.html"
                target="_blank"
                rel="noreferrer"
                aria-label="Övrig kontaktinformation"
              >
                Övrig kontaktinformation
              </a>
            </div>
          </div>

          <div className="faq_wrapper">
            <div className="page-title">Frågor och svar</div>
            <div className="question-and-answer">
              <a
                href="https://www.tolkformedlingvast.se/tolk/registrerad-tolk/vanliga-fragor-och-svar.html"
                target="_blank"
                rel="noreferrer"
                tabIndex={0}
                aria-label="Vanliga frågor och svar"
              >
                Vanliga frågor och svar
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="page-footer">
        <div className="d-flex mt-auto">
          <img
            alt="tfv-black"
            width={205}
            height={25}
            src="images/footer-logo.png"
          />
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
